import React, {ChangeEventHandler, ReactElement, ReactNode} from 'react'
import {DisplayItemSelect, DisplayItemSelectWrapper} from './DisplayItem'

interface Props {
    id?: string
    value?: string | string[] | number
    onChange?: ChangeEventHandler<HTMLSelectElement>
    disabled?: boolean
    hasError?: boolean
    children: ReactNode
}

export default class DisplayItemSelectComponent extends React.Component<Props> {
    render(): ReactElement {
        return (
            <DisplayItemSelectWrapper>
                <DisplayItemSelect
                    disabled={this.props.disabled}
                    hasError={this.props.hasError}
                    id={this.props.id}
                    value={this.props.value}
                    onChange={this.props.onChange}>
                    {this.props.children}
                </DisplayItemSelect>
            </DisplayItemSelectWrapper>
        )
    }
}
